<!--
 * @Author: Du
 * @Date: 2020-03-28 20:23:59
 * @LastEditTime: 2020-04-28 10:00:59
 * @FilePath: /cn-hxapi-client/src/Global.vue
 * @Description:
 -->
<script>
// 全局变量设置

const api = 'http://la.hxapi.cn/api' // 远程正式
const wapUrl = 'http://la.hxapi.cn/#'// 远程正式手机端访问的地址
const baseUrl = 'http://la.hxapi.cn'


// const api = 'http://localhost:8898/api' // 测试
// const baseUrl = 'http://www.hxapi.cn:8898'
// const wapUrl = 'http://47.95.217.43:8001/hxweb/#'// 远程测试手机端访问的地址
/*
const api = 'http://test.hxapi.cn/api' // 远程正式
const wapUrl = 'http://test.hxapi.cn/#'// 远程正式手机端访问的地址
const baseUrl = 'http://test.hxapi.cn'
*/

export default {
  api,
  baseUrl,
  wapUrl
}
</script>



// WEBPACK FOOTER //
// src/Global.vue